export const ROLE_OPTIONS = [
  { value: "admin", label: "Amministratore", hint: "Utenti, anagrafiche, configurazione" },
  { value: "valuatore", label: "Valutatore", hint: "Analisi documentale, stage 1-2, rating" },
  { value: "tech_reviewer", label: "Riesaminatore tecnico", hint: "Riesame tecnico" },
  { value: "decision_maker", label: "Deliberante", hint: "Delibera ed emissione certificato" },
  { value: "resp_metodologia", label: "Responsabile metodologia", hint: "Pesi, topic, benchmark, mapping ATECO" },
  { value: "partner", label: "Partner", hint: "Sola lettura sulle aziende dell'accordo" },
  { value: "cliente", label: "Cliente", hint: "Compila l'assessment della propria azienda" },
];

export const EXCLUSIVE_ROLES = ["cliente", "partner"];
export const INTERNAL_ROLES = ["admin", "valuatore", "tech_reviewer", "decision_maker", "resp_metodologia"];
export const ALL_ROLES = ROLE_OPTIONS.map((r) => r.value);

export const roleLabel = (r) => ROLE_OPTIONS.find((o) => o.value === r)?.label || r;

export function userRoles(user) {
  if (!user) return [];
  if (Array.isArray(user.roles) && user.roles.length) return user.roles;
  return user.role ? [user.role] : [];
}

export function hasRole(user, ...roles) {
  const mine = userRoles(user);
  return roles.some((r) => mine.includes(r));
}
